import styled, { css } from 'styled-components';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

export const textStyles = ({ theme }: any) => css`
    font-family: ${theme.colors.fontPrimary};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
`;

export const buttonLinkStyles = () => css`
    text-decoration: underline !important;
`;

export const StyledActionText = styled(ActionText)`
    ${textStyles}
    ${buttonLinkStyles}
`;

export const ShippingLineIcon = styled(FontAwesomeIcon)`
    height: auto;
    width: 30px !important;
    margin-right: 15px;
    color: ${({ theme }) => theme.colors.steel};
`;

export const ShippingLineLabel = styled(Text)`
    && {
        min-width: 79px;
        ${textStyles}
        font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
        &::after {
            content: ' ';
            white-space: pre;
        }
    }
`;

export const ShippingLineText = styled(Text)`
    && {
        ${textStyles}
    }
`;
